import { render, staticRenderFns } from "./EquipeIndividuo.vue?vue&type=template&id=32ffc42c&scoped=true"
import script from "./EquipeIndividuo.vue?vue&type=script&lang=js"
export * from "./EquipeIndividuo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ffc42c",
  null
  
)

export default component.exports